/**
 * Store locator das lojas Lev — réplica de /lojas da produção.
 *
 * The public store directory is a reviewed snapshot of /api/locations/all.
 * O comportamento abaixo é o do bundle da produção
 * (src/components/ui/Map/{index,Mapa,Lista,PlaceCard}.tsx), inclusive as
 * assimetrias: a busca do mapa não mexe na distância, e a distância é
 * formatada de um jeito na lista e de outro no balão. Os filtros Lojas Lev /
 * Autorizadas valem para pins e para a lista.
 *
 * The list remains available when map configuration or loading fails.
 */
(function () {
  const root = document.querySelector('[data-lev-lojas]');
  if (!root) return;

  // `parceirosVendas` divide o filtro com `parceiros`: na produção os dois são
  // "Autorizadas". O que os separa é o pin e a lista de serviços.
  const FILTRO_DE = { lev: 'lev', parceiros: 'parceiros', parceirosVendas: 'parceiros' };
  const NOTA = '*Em caso de feriados, verifique previamente a data de funcionamento para confirmar a disponibilidade do serviço.';

  // São Paulo é o ponto que a produção assume quando o visitante nega a
  // localização ou o navegador não tem geolocation.
  const FALLBACK = { lat: -23.55052, lng: -46.633308 };
  const CENTRO_BR = { lat: -14.235, lng: -51.9253 };

  // mapStyles.tsx — a produção desliga POI e cada subtipo separadamente.
  const ESTILO_MAPA = [
    'poi', 'poi.business', 'poi.attraction', 'poi.government', 'poi.medical',
    'poi.park', 'poi.place_of_worship', 'poi.school', 'poi.sports_complex',
  ].map((featureType) => ({ featureType, elementType: 'all', stylers: [{ visibility: 'off' }] }));

  const estado = {
    lojas: [],
    filtros: { lev: true, parceiros: true },
    origem: null,       // userLocation: só a geolocalização mexe nisso
    busca: '',          // texto da busca da lista
    aberta: null,       // loja do painel
    pendente: null,     // loja esperando o painel fechar para entrar
    painelAberto: false,
    abrirPrimeira: false, // deep-link: expandir o primeiro card após filtrar
  };

  const $ = (sel) => root.querySelector(sel);
  const cards = $('[data-cards]');
  const slide = $('[data-slide]');
  const place = $('[data-place]');

  // ---------------------------------------------------------------------------
  // Dados
  // ---------------------------------------------------------------------------

  let loadingDirectory = false;
  function carregarLojas() {
    if (loadingDirectory) return;
    loadingDirectory = true;
    const controller = new AbortController();
    const loadTimeout = setTimeout(() => controller.abort(), 10000);
    cards.setAttribute('aria-busy', 'true');
    cards.innerHTML = '<p class="lev-lojas__empty" role="status">Carregando lojas…</p>';
    fetch(root.dataset.url, { signal: controller.signal })
      .then((response) => {
        if (!response.ok) throw new Error('Store directory unavailable');
        return response.json();
      })
      .then((d) => {
        // A produção monta a lista como [...lev, ...parceiros, ...parceirosVendas];
        // sem origem para ordenar, é essa ordem que aparece.
        const ordem = { lev: 0, parceiros: 1, parceirosVendas: 2 };
        if (!Array.isArray(d.lojas)) throw new Error('Invalid store directory');
        estado.lojas = d.lojas
          .map((l, i) => ({ ...l, _i: i }))
          .sort((a, b) => (ordem[a.categoria] - ordem[b.categoria]) || (a._i - b._i));
        render();
        desenharPins();
      })
      .catch(() => {
        cards.innerHTML = '<p class="lev-lojas__empty" role="alert">Não foi possível carregar as lojas.</p><button type="button" data-directory-retry>Tentar novamente</button>';
      })
      .finally(() => { clearTimeout(loadTimeout); loadingDirectory = false; cards.setAttribute('aria-busy', 'false'); });
  }
  cards.addEventListener('click', event => {
    if (event.target.closest('[data-directory-retry]')) carregarLojas();
  });

  // A distância é medida a partir de onde o visitante está. Negar a permissão
  // não deixa a página sem distância: cai no mesmo ponto que a produção usa.
  function localizar() {
    const usar = (p) => {
      estado.origem = p;
      // A permissão pode voltar antes do fetch das lojas; sem a guarda o
      // render pintaria "nenhuma loja" e piscaria quando os dados chegassem.
      if (estado.lojas.length) render();
      if (mapa) {
        mapa.setCenter(p);
        mapa.setZoom(12);
      }
    };
    if (!navigator.geolocation) return usar(FALLBACK);
    try {
      navigator.geolocation.getCurrentPosition(
        (pos) => usar({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
        () => usar(FALLBACK),
        { timeout: 8000, maximumAge: 300000 }
      );
    } catch {
      usar(FALLBACK);
    }
  }

  /** Haversine, arredondado a uma casa — é o número que a produção mostra. */
  function distanciaKm(a, b) {
    const R = 6371;
    const rad = (x) => (x * Math.PI) / 180;
    const dLat = rad(b.lat - a.lat);
    const dLng = rad(b.lng - a.lng);
    const h =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(dLng / 2) ** 2;
    return Math.round(2 * R * Math.asin(Math.sqrt(h)) * 10) / 10;
  }

  function escapar(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, (c) =>
      ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c])
    );
  }

  /** wa.me exige DDI. A produção prefixa 55 quando o cadastro não tem. */
  function zap(telefone) {
    const so = String(telefone || '').replace(/\D/g, '');
    if (!so) return '';
    return so.startsWith('55') ? so : `55${so}`;
  }

  // ---------------------------------------------------------------------------
  // Serviços — saem da categoria, e a ordem muda entre a lista e o painel:
  // no painel de `parceirosVendas` vem vendas antes de suporte, na lista vem
  // suporte antes de vendas. É assim na produção.
  // ---------------------------------------------------------------------------

  const SERVICOS_PAINEL = {
    lev: ['retail', 'support', 'test'],
    parceirosVendas: ['retail', 'support'],
    parceiros: ['support'],
  };
  const SERVICOS_LISTA = {
    lev: ['retail', 'support', 'test'],
    parceirosVendas: ['support', 'retail'],
    parceiros: ['support'],
  };
  const ROTULO_SERVICO = { retail: 'Retail', support: 'Support', test: 'Test' };

  function iconesServico(categoria, mapa_) {
    return (mapa_[categoria] || mapa_.parceiros)
      .map(
        (k) =>
          `<img src="${root.dataset['icon' + k[0].toUpperCase() + k.slice(1)]}" alt="${ROTULO_SERVICO[k]}" width="48" height="48">`
      )
      .join('');
  }

  // ---------------------------------------------------------------------------
  // Lista
  // ---------------------------------------------------------------------------

  function render() {
    const busca = estado.busca.toLowerCase();
    let lista = estado.lojas.filter((l) => {
      const tipo = FILTRO_DE[l.categoria];
      if (!estado.filtros[tipo]) return false;
      if (!busca) return true;
      return (
        String(l.nome).toLowerCase().includes(busca) ||
        String(l.endereco).toLowerCase().includes(busca)
      );
    });

    if (estado.origem) {
      lista = lista
        .map((l) => ({ ...l, dist: distanciaKm(estado.origem, l) }))
        .sort((a, b) => a.dist - b.dist);
    }

    if (!lista.length) {
      cards.innerHTML = '<p class="lev-lojas__empty" role="status">Nenhuma loja encontrada. Tente outro endereço ou cidade.</p>';
      return;
    }

    cards.innerHTML = lista
      .map((l, i) => {
        const autorizada = l.categoria !== 'lev';
        const filtro = FILTRO_DE[l.categoria];
        const rotulo = autorizada ? 'Autorizadas' : 'Lojas Lev';
        // "845.3km de você" — número cru, sem casa forçada: 845 fica "845km".
        const dist = l.dist != null ? `${l.dist}km de você` : 'Distância não disponível';
        const pinLista = autorizada ? root.dataset.pinListaAmarelo : root.dataset.pinListaAzul;
        const chevron = autorizada ? root.dataset.chevronAzul : root.dataset.chevronBranco;
        const h = l.horarios || {};
        const numero = zap(l.telefone);
        // Três faixas: rótulo, conteúdo e o rodapé bege que abre. O rodapé fica
        // fora da cor da categoria de propósito.
        return `
          <div class="lev-lojas__card lev-lojas__card--${filtro}" data-i="${i}">
            <div class="lev-lojas__card-head">${rotulo}</div>
            <div class="lev-lojas__card-main" role="button" tabindex="0" aria-expanded="false" aria-controls="lev-store-details-${i}" aria-label="Ver serviços e horários de ${escapar(l.nome)}">
              <div>
                <h2 class="lev-lojas__card-name">${escapar(l.nome)}</h2>
                <div class="lev-lojas__card-dist"><img src="${pinLista}" alt="Location" width="14" height="16"><span>${escapar(dist)}</span></div>
                <p class="lev-lojas__card-addr">${escapar(l.endereco)}</p>
              </div>
              <img class="lev-lojas__chevron" src="${chevron}" alt="Expand" width="24" height="24">
            </div>
            <div class="lev-lojas__card-foot" id="lev-store-details-${i}" aria-hidden="true" inert>
              <h4>Serviços oferecidos</h4>
              <div class="lev-lojas__card-servicos">${iconesServico(l.categoria, SERVICOS_LISTA)}</div>
              <h4 style="margin-top:16px">Funcionamento</h4>
              <div class="lev-lojas__hours-row">
                <div class="lev-lojas__hours">
                  <div><strong>Seg - Qui</strong><span>${escapar(h.Monday || '')}</span></div>
                  <div><strong>Sex</strong><span>${escapar(h.Friday || '')}</span></div>
                  <div><strong>Sáb</strong><span>${escapar(h.Saturday || '')}</span></div>
                  <div><strong>Dom</strong><span>${escapar(h.Sunday || '')}</span></div>
                </div>
                ${numero ? `<a class="lev-lojas__card-wa" target="_blank" rel="noopener noreferrer" href="https://wa.me/${numero}" aria-label="WhatsApp"><img src="${root.dataset.iconWaLogo}" alt="WhatsApp" loading="lazy" width="32" height="32"></a>` : ''}
              </div>
              <p class="lev-lojas__note">${NOTA}</p>
            </div>
          </div>`;
      })
      .join('');

    cards.querySelectorAll('.lev-lojas__card').forEach((el) => {
      const toggle = () => {
        const wasOpen = el.classList.contains('is-open');
        cards.querySelectorAll('.lev-lojas__card').forEach(card => {
          const expanded = card === el && !wasOpen;
          card.classList.toggle('is-open', expanded);
          card.querySelector('[role="button"]').setAttribute('aria-expanded', String(expanded));
          const details = card.querySelector('.lev-lojas__card-foot');
          details.setAttribute('aria-hidden', String(!expanded));
          details.inert = !expanded;
        });
      };
      el.addEventListener('click', toggle);
      el.querySelector('[role="button"]').addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          toggle();
        }
      });
    });
    // O link do WhatsApp abre sozinho; sem isso o clique também abriria o card.
    cards.querySelectorAll('.lev-lojas__card-wa').forEach((a) => {
      a.addEventListener('click', (e) => e.stopPropagation());
    });

    if (estado.abrirPrimeira) {
      estado.abrirPrimeira = false;
      const first = cards.querySelector('.lev-lojas__card');
      if (first) {
        first.classList.add('is-open');
        const trigger = first.querySelector('[role="button"]');
        const details = first.querySelector('.lev-lojas__card-foot');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
        if (details) {
          details.setAttribute('aria-hidden', 'false');
          details.inert = false;
        }
        first.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    }
  }

  // ---------------------------------------------------------------------------
  // Mapa
  // ---------------------------------------------------------------------------

  let mapa = null;
  let marcadores = [];
  let marcadorAtivo = null;
  let pronto = false;
  let timerDistancia = null;

  /**
   * O balão de distância aparece por 3s a cada loja selecionada e some — é um
   * `setTimeout` na produção, não um estado permanente. Aqui a distância vem
   * com uma casa forçada (`toFixed(1)`), ao contrário da lista.
   */
  function mostrarDistancia(loja) {
    const box = $('[data-dist]');
    if (!box) return;
    if (timerDistancia) clearTimeout(timerDistancia);
    if (!loja || !estado.origem) {
      box.hidden = true;
      return;
    }
    box.textContent = `${distanciaKm(estado.origem, loja).toFixed(1)}km de você`;
    box.hidden = false;
    timerDistancia = setTimeout(() => {
      box.hidden = true;
    }, 3000);
  }

  const LOCAL_MAPS_API = 'http://127.0.0.1:3002';
  const NETLIFY_MAPS_API = 'https://lev-minhaconta.netlify.app';

  function mapsApiBase() {
    const host = window.location.hostname;
    if (host === '127.0.0.1' || host === 'localhost') return LOCAL_MAPS_API;
    return (root.dataset.apiBase || NETLIFY_MAPS_API).replace(/\/$/, '');
  }

  async function chaveDoMapa() {
    const inline = String(root.dataset.key || '').trim();
    if (inline) return inline;
    const response = await fetch(`${mapsApiBase()}/api/maps/config`);
    if (!response.ok) return '';
    const body = await response.json();
    return typeof body.key === 'string' ? body.key.trim() : '';
  }

  let mapLoadTimer;
  function setView(view) {
    root.dataset.view = view;
    root.querySelectorAll('[data-view-btn]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.viewBtn === view)));
  }
  function mapUnavailable() {
    if (pronto) return;
    setView('lista');
    const button = $('[data-view-btn="mapa"]');
    if (button) button.disabled = true;
    const status = $('[data-map-status]');
    if (status) { status.hidden = false; status.textContent = 'O mapa está indisponível. Consulte as lojas na lista abaixo.'; }
  }
  async function iniciarMapa() {
    const alvo = $('[data-mapa]');
    if (!alvo) return;
    let chave = '';
    try {
      chave = await chaveDoMapa();
    } catch {
      chave = '';
    }
    if (!chave) {
      mapUnavailable();
      return;
    }

    mapLoadTimer = setTimeout(mapUnavailable, 8000);
    if (window.google && window.google.maps && window.google.maps.places) return montarMapa();

    const s = document.createElement('script');
    // v=quarterly, como na produção: prende a versão dos tiles e do Marker.
    s.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(chave)}&libraries=places&v=quarterly`;
    s.async = true;
    s.defer = true;
    s.onload = () => {
      try { montarMapa(); } catch { mapUnavailable(); }
    };
    s.onerror = mapUnavailable;
    document.head.appendChild(s);
  }

  function montarMapa() {
    const alvo = $('[data-mapa]');
    if (!alvo || !window.google) return;

    mapa = new google.maps.Map(alvo, {
      center: estado.origem || CENTRO_BR,
      zoom: estado.origem ? 12 : 4,
      styles: ESTILO_MAPA,
      disableDefaultUI: true,
    });

    // Clicar no mapa fecha o painel.
    mapa.addListener('click', () => {
      fecharPainel();
      if (marcadorAtivo) {
        marcadorAtivo.setAnimation(null);
        marcadorAtivo = null;
      }
    });

    // O mapa só entra em cena quando os tiles apareceram — até lá fica a foto.
    google.maps.event.addListenerOnce(mapa, 'tilesloaded', () => {
      pronto = true;
      clearTimeout(mapLoadTimer);
      const button = $('[data-view-btn="mapa"]');
      if (button) button.disabled = false;
      const status = $('[data-map-status]');
      if (status) status.hidden = true;
      root.dataset.ready = '';
      desenharPins();
    });

    prepararAutocomplete();
  }

  function marcadorDe(categoria) {
    if (categoria === 'lev') return root.dataset.markerLev;
    if (categoria === 'parceirosVendas') return root.dataset.markerVendas;
    return root.dataset.markerParceiros;
  }

  function pinDe(categoria) {
    if (categoria === 'lev') return root.dataset.pinLev;
    if (categoria === 'parceirosVendas') return root.dataset.pinVendas;
    return root.dataset.pinParceiros;
  }

  function desenharPins() {
    if (!mapa || !pronto || !estado.lojas.length) return;
    marcadores.forEach((m) => m.setMap(null));
    marcadores = [];
    marcadorAtivo = null;

    estado.lojas.forEach((l) => {
      const m = new google.maps.Marker({
        position: { lat: l.lat, lng: l.lng },
        map: mapa,
        title: l.nome,
        // 60x69 é o tamanho da produção; os `pin_*` menores são do painel.
        icon: { url: marcadorDe(l.categoria), scaledSize: new google.maps.Size(60, 69) },
        animation: google.maps.Animation.DROP,
        // Pin Lev sempre por cima do amarelo.
        zIndex: l.categoria === 'lev' ? 1000 : 100,
      });
      m.loja = l;
      m.addListener('click', () => clicarMarcador(m, l));
      marcadores.push(m);
    });

    aplicarFiltros();
  }

  /** O filtro não recria os pins: só tira e devolve o mapa de cada um. */
  function aplicarFiltros() {
    if (!mapa) return;
    marcadores.forEach((m) => {
      const mostrar = estado.filtros[FILTRO_DE[m.loja.categoria]];
      m.setMap(mostrar ? mapa : null);
    });
  }

  function clicarMarcador(marcador, loja) {
    if (marcadorAtivo) marcadorAtivo.setAnimation(null);

    // Clicar de novo no pin da loja aberta fecha o painel.
    if (estado.aberta && estado.aberta.nome === loja.nome) {
      fecharPainel();
      marcador.setAnimation(null);
      marcadorAtivo = null;
      return;
    }

    mapa.setCenter({ lat: loja.lat, lng: loja.lng });
    mapa.setZoom(16);
    marcador.setAnimation(google.maps.Animation.BOUNCE);
    marcadorAtivo = marcador;

    // Com o painel aberto, a loja nova espera o fechamento terminar: é a
    // troca com o deslize de saída e entrada que a produção faz.
    if (estado.painelAberto) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        abrirPainel(loja);
        return;
      }
      estado.pendente = loja;
      estado.painelAberto = false;
      slide.classList.remove('is-open');
      return;
    }

    abrirPainel(loja);
  }

  function fecharPainel() {
    estado.painelAberto = false;
    estado.pendente = null;
    slide.classList.remove('is-open');
    setTimeout(() => {
      if (!estado.painelAberto) {
        estado.aberta = null;
        place.innerHTML = '';
      }
    }, 300);
  }

  // Ponta do deslize de saída: troca o conteúdo e manda entrar de novo.
  slide.addEventListener('transitionend', () => {
    if (estado.painelAberto || !estado.pendente) return;
    const loja = estado.pendente;
    estado.pendente = null;
    pintarPainel(loja);
    setTimeout(() => {
      estado.painelAberto = true;
      slide.classList.add('is-open');
    }, 50);
  });

  function abrirPainel(loja) {
    pintarPainel(loja);
    estado.painelAberto = true;
    // Força o cálculo do estado fechado antes de mandar abrir; sem essa
    // leitura o browser junta as duas mudanças e o painel aparece já no lugar,
    // sem deslizar.
    void slide.offsetWidth;
    slide.classList.add('is-open');
  }

  // ---------------------------------------------------------------------------
  // PlaceCard — o painel que abre ao clicar num pin.
  // ---------------------------------------------------------------------------

  const NOME_DIA = {
    Monday: 'Segunda-feira', Tuesday: 'Terça-feira', Wednesday: 'Quarta-feira',
    Thursday: 'Quinta-feira', Friday: 'Sex', Saturday: 'Sáb', Sunday: 'Dom',
  };

  const UF = /^(RJ|SP|PA|MG|ES|RS|SC|PR|MS|GO|DF|TO|AC|AP|AM|RR|RO|PB|PE|AL|SE|BA|PI|CE|RN|MA)$/i;
  const capitalizar = (p) => p.charAt(0).toUpperCase() + p.slice(1).toLowerCase();

  /**
   * Porte fiel do `formatAddress` da produção, com as manias dele:
   *
   *  - só tira CEP colado no fim da string (o cadastro quase sempre termina em
   *    ", Brazil", então na prática o CEP não sai por aqui);
   *  - usa apenas as TRÊS primeiras partes separadas por vírgula, e é isso que
   *    corta o CEP e o "Brazil" do fim;
   *  - capitaliza palavra por palavra na rua ("Aníbal De Mendonça"), mas deixa
   *    a terceira parte intocada ("Rio de Janeiro - RJ"), porque lá ela é
   *    tratada como país.
   *
   * Parece errado, e é — mas é o texto que está no ar.
   */
  function formatarEndereco(endereco) {
    const semCep = String(endereco || '').replace(/\d{5}-?\d{3}?$/, '').trim();
    const partes = semCep.split(',').map((p) => p.trim());

    const rua = partes[0].split(' ').map(capitalizar).join(' ');
    const cidadeUf = partes[1]
      ? partes[1].split(' ').map((p) => (UF.test(p) ? p.toUpperCase() : capitalizar(p))).join(' ')
      : '';
    const pais = partes[2] ? partes[2].trim().replace(/Brazil/i, 'Brasil') : '';

    return [rua, cidadeUf, pais].filter(Boolean).join(', ');
  }

  function horasHtml(h) {
    if (!h || !Object.keys(h).length) return '';
    const seg = h.Monday;
    const iguais = ['Monday', 'Tuesday', 'Wednesday', 'Thursday'].every((d) => h[d] === seg);
    const linha = (rot, val) => `<p><strong>${escapar(rot)}</strong> ${escapar(val)}</p>`;
    if (iguais) {
      return (
        linha('Seg - Qui', seg) +
        ['Friday', 'Saturday', 'Sunday'].map((d) => linha(NOME_DIA[d], h[d])).join('')
      );
    }
    return Object.entries(h).map(([d, v]) => linha(NOME_DIA[d] || d, v)).join('');
  }

  function pintarPainel(l) {
    estado.aberta = l;
    const numero = zap(l.telefone);

    place.innerHTML = `
      <div class="lev-lojas__place-head">
        <div class="lev-lojas__place-pin"><img src="${pinDe(l.categoria)}" alt="Logo" width="60" height="69"></div>
        <div class="lev-lojas__place-titlewrap">
          <h2 class="lev-lojas__place-title">${escapar(String(l.nome).toUpperCase())}</h2>
          <div class="lev-lojas__place-line"></div>
        </div>
      </div>
      <p class="lev-lojas__place-addr">${escapar(formatarEndereco(l.endereco))}</p>
      <a class="lev-lojas__place-btn lev-lojas__place-nav" target="_blank" rel="noopener noreferrer"
         href="https://www.google.com/maps/dir/?api=1&destination=${l.lat},${l.lng}">
        <span>Navegar</span>
        <img src="${root.dataset.iconClick}" alt="Ícone de Navegação" width="16" height="16">
      </a>
      <div class="lev-lojas__place-services">
        <h3>SERVIÇOS OFERECIDOS</h3>
        <div class="lev-lojas__place-icons">${iconesServico(l.categoria, SERVICOS_PAINEL)}</div>
      </div>
      <div class="lev-lojas__place-hours">
        <h3>FUNCIONAMENTO</h3>
        ${horasHtml(l.horarios)}
        <p class="lev-lojas__place-note">${NOTA}</p>
      </div>
      ${numero ? `<a class="lev-lojas__place-btn lev-lojas__place-wa" target="_blank" rel="noopener noreferrer" href="https://wa.me/${numero}"><span>WhatsApp</span><img src="${root.dataset.iconWa}" alt="Ícone de WhatsApp" width="16" height="16"></a>` : ''}
    `;
    mostrarDistancia(l);
  }

  // ---------------------------------------------------------------------------
  // Interação
  // ---------------------------------------------------------------------------

  setView(root.dataset.view);
  root.querySelectorAll('[data-view-btn]').forEach((btn) => {
    // Selecting an already active view must keep it active.
    btn.addEventListener('click', () => {
      setView(btn.dataset.viewBtn);
    });
  });

  function sincronizarFiltros() {
    root.querySelectorAll('[data-filtro]').forEach((btn) => {
      const ligado = Boolean(estado.filtros[btn.dataset.filtro]);
      btn.setAttribute('aria-pressed', String(ligado));
      btn.classList.toggle('is-active', ligado);
    });
  }

  root.querySelectorAll('[data-filtro]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const chave = btn.dataset.filtro;
      estado.filtros[chave] = !estado.filtros[chave];
      sincronizarFiltros();
      aplicarFiltros();
      render();
    });
  });

  // Busca do mapa — só recentra. Não mexe na distância nem na lista, igual à
  // produção.
  const inputMapa = $('[data-busca]');

  /** getZoomForPlaceTypes: cidade 11, bairro 15, endereço 19, resto 14. */
  function zoomPara(tipos) {
    const t = tipos || [];
    if (t.includes('locality') || t.includes('administrative_area_level_1')) return 11;
    if (t.includes('sublocality') || t.includes('neighborhood')) return 15;
    if (t.includes('street_address') || t.includes('establishment') || t.includes('point_of_interest')) return 19;
    return 14;
  }

  function centrarEm(pos, tipos) {
    if (!mapa) return;
    mapa.setCenter(pos);
    mapa.setZoom(zoomPara(tipos));
  }

  function prepararAutocomplete() {
    if (!inputMapa || !window.google || !google.maps.places) return;
    const ac = new google.maps.places.Autocomplete(inputMapa, {
      fields: ['geometry', 'name', 'formatted_address', 'types'],
      componentRestrictions: { country: 'br' },
    });
    ac.addListener('place_changed', () => {
      const p = ac.getPlace();
      if (p && p.geometry) {
        centrarEm({ lat: p.geometry.location.lat(), lng: p.geometry.location.lng() }, p.types);
      }
    });
  }

  function buscarNoMapa() {
    const endereco = (inputMapa && inputMapa.value || '').trim();
    if (!endereco || !window.google || !google.maps.Geocoder) return;
    new google.maps.Geocoder().geocode({ address: endereco, region: 'br' }, (res, status) => {
      if (status === 'OK' && res && res.length) {
        centrarEm(res[0].geometry.location, res[0].types);
      }
    });
  }

  if (inputMapa) {
    $('[data-buscar]').addEventListener('click', buscarNoMapa);
    inputMapa.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') buscarNoMapa();
    });
  }

  // Busca da lista — filtro de texto ao digitar ou no botão Buscar.
  const inputLista = $('[data-busca-lista]');
  function buscarNaLista() {
    if (!inputLista) return;
    estado.busca = inputLista.value;
    render();
  }
  if (inputLista) {
    inputLista.addEventListener('input', buscarNaLista);
    inputLista.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') buscarNaLista();
    });
  }
  const btnBuscarLista = $('[data-buscar-lista]');
  if (btnBuscarLista) btnBuscarLista.addEventListener('click', buscarNaLista);

  // Cards da home/cruiser gravam o nome em sessionStorage e abrem /pages/lojas.
  // Aqui a busca da lista é preenchida com esse valor (sem query na URL).
  (function aplicarDeepLink() {
    let q = '';
    try {
      q = String(sessionStorage.getItem('lev-lojas-busca') || '').trim();
      if (q) sessionStorage.removeItem('lev-lojas-busca');
    } catch {
      q = '';
    }
    if (!q) return;
    setView('lista');
    if (inputLista) inputLista.value = q;
    if (inputMapa) inputMapa.value = q;
    estado.busca = q;
    estado.abrirPrimeira = true;
  })();

  // Initialize only after map state and search controls exist, including cached APIs.
  carregarLojas();
  localizar();
  iniciarMapa();
})();
